import React from 'react';

const CheckboxLabel = () => (
  <>
    J&apos;ai lu et j&apos;accepte les
    {' '}
    <a href="/a-propos/conditions-particulieres-avis" target="_blank" rel="noreferrer noopener">
      Conditions particulières relatives aux avis
    </a>
  </>
);

export { CheckboxLabel };
